import { MappedFormItem } from '@/components/elements/form-map/form-map.component.core';
import { ProductGroup, Template } from '@/gql/graphql';
import { IntlShape } from 'react-intl';
import { productFormTranslations } from '../../products.messages';

export const productMap = (
  context: 'product' | 'template',
  intl: IntlShape,
  templates: Template[],
  edit?: boolean,
  productGroups?: ProductGroup[],
): MappedFormItem[] => {
  const map: MappedFormItem[] = [];
  let options = productGroups;
  if (!options) options = [];

  map.push({
    name: 'groupId',
    label: intl.formatMessage(productFormTranslations.productGroupInputLabel),
    placeholder: intl.formatMessage(productFormTranslations.productGroupInputPlaceholder),
    required: true,
    type: 'select',
    disabled: !edit && context === 'product',
    options: options.map((pg) => ({
      label: pg.name,
      value: pg.id,
      testId: `product-group-${pg.id}`,
    })),
  });

  const rest: MappedFormItem[] = [
    {
      name: 'name',
      label: intl.formatMessage(productFormTranslations.nameInputLabel),
      placeholder: intl.formatMessage(productFormTranslations.nameInputPlaceholder),
      required: true,
      type: 'input',
    },
    {
      name: 'description',
      label: intl.formatMessage(productFormTranslations.descriptionInputLabel),
      placeholder: intl.formatMessage(productFormTranslations.descriptionInputPlaceholder),
      required: true,
      type: 'textarea',
    },
    {
      name: 'version',
      label: intl.formatMessage(productFormTranslations.productVersionInputLabel),
      placeholder: intl.formatMessage(productFormTranslations.productVersionInputPlaceholder),
      required: true,
      type: 'input',
    },
    {
      name: 'productIdentifier',
      label: intl.formatMessage(productFormTranslations.productProductIdentifierInputLabel),
      placeholder: intl.formatMessage(productFormTranslations.productProductIdentifierInputPlaceholder),
      required: false,
      type: 'input',
    },
    {
      name: 'projectIdentifier',
      label: intl.formatMessage(productFormTranslations.productProjectIdentifierInputLabel),
      placeholder: intl.formatMessage(productFormTranslations.productProjectIdentifierInputPlaceholder),
      required: false,
      type: 'input',
    },
  ];

  map.push(...rest);

  if (!edit) {
    map.push({
      name: 'copyAnswersFrom',
      label: intl.formatMessage(productFormTranslations.productTemplateSelectLabel),
      placeholder: intl.formatMessage(productFormTranslations.productTemplateSelectPlaceholder),
      required: false,
      type: 'select',
      options: templates.map((template) => ({
        label: template.name,
        value: template.id,
        testId: `copy-answers-from-${template.id}`,
      })),
    });
  }

  return map;
};
